// extracted by mini-css-extract-plugin
export default {"badge":"TimerBadge_badge__fj1-A","small":"TimerBadge_small__J5RXs","endsSoon":"TimerBadge_endsSoon__iJm1I","large":"TimerBadge_large__hK80m"};